export function getUpgradeUrl(lang: string = 'us'): string {
  return `${process.env.OFFICE}/${lang}/office/upgrade`;
  // return process.env.CHECKOUT_URL;
}
